import React from 'react';
import { useSelector } from 'react-redux';

const HasRole = (RoleProtectedComponent, allowedRoles, DefaultComponent) => {
  const HasRoleComponent = props => {
    const authenticatedUser = useSelector(
      state => state.auth.authenticatedUser
    );
    if (allowedRoles.indexOf(authenticatedUser.roleName) >= 0) {
      return <RoleProtectedComponent {...props} />;
    }

    if (DefaultComponent) {
      return <DefaultComponent {...props} />;
    }

    return null;
  };

  return HasRoleComponent;
};

export default HasRole;
